import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { api } from "../api";
import FixedCard from "../components/FixedCard";
import SEO from "../components/SEO";

export default function Team() {
  const [team, setTeam]     = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.getTeam().then(setTeam).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const ACCENT = ["#8A1613","#007965"];

  return (
    <>
    <SEO
      title="Meet the Team"
      path="/team"
      description="Meet the people behind The Health Plug — a team of health communicators, journalists and creatives dedicated to making health information accessible and youth-centred in South Africa."
    />
    <div style={{ paddingTop:"5rem" }}>
      <section style={{ background:"#0B0B0B", padding:"6rem 2rem 5rem" }}>
        <div className="container">
          <p className="section-label" style={{ color:"#95BB83" }}>The People</p>
          <h1 style={{ fontFamily:"var(--font)", fontWeight:900, fontSize:"clamp(2.8rem,7vw,6rem)", color:"#fff", lineHeight:0.95, letterSpacing:"-0.03em" }}>
            Meet the<br /><span style={{ color:"#8A1613" }}>Team.</span>
          </h1>
        </div>
      </section>

      <section style={{ background:"#F7F1DF", padding:"6rem 2rem" }}>
        <div className="container">
          {loading && <p style={{ color:"rgba(11,11,11,0.4)", fontFamily:"var(--font-body)" }}>Loading team…</p>}
          {!loading && team.length === 0 && (
            <p style={{ textAlign:"center", color:"rgba(11,11,11,0.4)", fontFamily:"var(--font-body)" }}>Team profiles coming soon.</p>
          )}

          <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill, minmax(240px, 1fr))", gap:"1.5rem" }}>
            {team.map((m, i) => {
              const color = ACCENT[i % ACCENT.length];
              return (
                <FixedCard
                  key={m.id}
                  height={360}
                  headerHeight={160}
                  accentColor={color}
                  headerContent={
                    m.photo_url
                      ? <img src={m.photo_url} alt={m.name}
                          style={{ position:"absolute", inset:0, width:"100%", height:"100%", objectFit:"cover" }} />
                      : <span style={{ fontSize:"4.5rem", zIndex:1, position:"relative" }}>👤</span>
                  }
                  eyebrow={m.role}
                  title={m.name}
                  body={m.bio}
                  previewLines={3}
                  modalTitle={m.name}
                  modalSubtitle={m.role}
                  modalIcon={m.photo_url || null}
                  modalIsPhoto={!!m.photo_url}
                  modalExtra={
                    m.linkedin_url
                      ? <a href={m.linkedin_url} target="_blank" rel="noreferrer"
                          style={{ fontFamily:"var(--font)", fontWeight:700, fontSize:"0.85rem", color:"#007965" }}>
                          LinkedIn →
                        </a>
                      : null
                  }
                />
              );
            })}
          </div>

          {!loading && (
            <div style={{ background:"#0B0B0B", borderRadius:24, padding:"3rem", textAlign:"center", marginTop:"3rem" }}>
              <p style={{ fontFamily:"var(--font)", fontWeight:900, fontSize:"1.5rem", color:"#fff", marginBottom:"0.75rem" }}>Collaborate with us.</p>
              <p style={{ color:"rgba(255,255,255,0.5)", fontFamily:"var(--font-body)", marginBottom:"1.5rem" }}>We're always looking for passionate storytellers, health communicators and creative content creators to collaborate with.</p>
              <Link to="/contact" className="btn-red">Connect</Link>
            </div>
          )}
        </div>
      </section>
    </div>
    </>
  );
}
